import { Component, OnInit, ChangeDetectorRef, NgZone, OnDestroy, AfterViewInit } from '@angular/core';
import { AuthenticationService } from '../../authentication.service';
import { ProfileService } from '../../services/profile.service';
import { GoogleAnalyticsService } from '../../services/google-analytics.service';
import { DateOfBirthPipe } from '../../pipes/date-of-birth.pipe';
import { Subscription } from 'rxjs';
import { openModal, closeModal } from '../../shared/modal-functions';
import { profileView } from './profile.static.data';
declare var jQuery: any;

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['../../app.component.css']
})

export class ProfileComponent implements OnInit, AfterViewInit, OnDestroy {
  // Static data
  profileView: any;
  // Control view
  openModal: any;
  closeModal: any;
  // Authentication and user data
  isLoggedin: boolean;
  isLoggedInSubscription: Subscription;
  private localStorage = window.localStorage;
  // User data
  user: User;
  standardLogin: boolean;

  constructor(public authenticationService: AuthenticationService, private ref: ChangeDetectorRef, public zone: NgZone, private profileService: ProfileService, public googleAnalyticsService: GoogleAnalyticsService) {
    this.profileView = profileView;
    this.openModal = openModal;
    this.closeModal = closeModal;
  }

  ngOnInit() {  
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.constructProfile();
    });
  }

  ngOnDestroy(): void {
    if (this.isLoggedInSubscription) {
      this.isLoggedInSubscription.unsubscribe();      
    }
  }
  
  /*
    * Check if user has been authenticated. 
    * If user is authenticated, bind and display user profile data
    * If user is not authenticated, display Gigya login screenset
  */
  constructProfile() {
    this.isLoggedInSubscription = this.authenticationService.getIsAuthenticated().subscribe((IsAuthenticated) => {
      this.zone.run(() => {
        if (IsAuthenticated && !this.authenticationService.isTokenExpired()) {
          this.bindUserAndAddDateOfBirth();
          this.isLoggedin = IsAuthenticated;
          this.standardLogin = JSON.parse(this.localStorage.getItem('session')).provider === ''; 
		}
        IsAuthenticated && this.authenticationService.isTokenExpired() ? this.authenticationService.logoutUserExpiredSession(): '';
      });
    });
  }

  /*
    * Display Gigya screenset to update user's personal information
    * Receive updated user profile object, bind and display user profile data.\
  */
  editProfile() {
    this.profileService.editProfile().subscribe((updatedUserProfile) => {
      this.authenticationService.userProfile = updatedUserProfile;
      this.bindUserAndAddDateOfBirth();
      this.ref.detectChanges();
      this.submitGAEvent('Mi_Perfil_SAM', 'Click', 'Pantalla_Confirmando_Envio_Cambio_Perfil');
    });
  }

  /*
    * Display Gigya screenset to change user's password 
    * Displays confirmation message when the password has been successfully changed 
  */
  changePassword() {
    this.profileService.changePassword().subscribe(() => {
      this.openModal('#changePasswordConfirmationModal');    
      this.submitGAEvent('Mi_Perfil_SAM', 'Click', 'Pantalla_Cambio_Contrasena_Efectivo');
    });
  }

  /*
   *  Transform user's date of birth, adds date of birth to user profile object and
   *  binds user profile object that is being stored in the service (this.authenticationService.userProfile) 
   *  to component's variable (this.user)
  */
  bindUserAndAddDateOfBirth(){
    if (this.authenticationService.userProfile && this.authenticationService.userProfile.birthDay && this.authenticationService.userProfile.birthMonth && this.authenticationService.userProfile.birthYear) {
      const dateOfBirth = new DateOfBirthPipe().transform([this.authenticationService.userProfile.birthDay, this.authenticationService.userProfile.birthMonth, this.authenticationService.userProfile.birthYear]);
      this.authenticationService.userProfile.dateOfBirth = dateOfBirth;
    }
    this.user = this.authenticationService.userProfile;
  }

  /*
    * Retrieves selected image file and checks image type
    * Displays error message if image type is not supported
    * If image type is supported, executes function to change user's profile photo
  */
  onChange(files) {
    const profilePhoto = files[0];
    if(profilePhoto) {
      if (!this.isImageTypeSupported(profilePhoto.name)) {
        this.openModal('#invalidImageTypeModal');
      } else {
        const reader = new FileReader;
        reader.onload = this.imageIsLoaded;
        // reader.onloadend = this.imageIsLoaded;    
        reader.readAsDataURL(profilePhoto);
      }
    }
  }

  /*
   * The result attribute contains the data as a URL representing the file's data as a base64 encoded string
   * Executes Gigya function to change user's profile photo
   * Displays confirmation message when the photo has been successfully updated
  */
  imageIsLoaded = (e) => { 
    const result = e.target.result;
    jQuery('#profileImage').attr('src', result);
    this.profileService.changeProfilePhoto(result).subscribe(() => {
      this.openModal('#changeProfilePhotoConfirmationModal');
      this.profileService.getAccountInfo().subscribe((profile) => {
        this.authenticationService.userProfile.thumbnailURL = profile.thumbnailURL;
        this.ref.detectChanges();
      });
    });
  }
    
  /*
   * Returns if selected image is supported
   * Gigya supported image types: png, jpeg, and gif
  */
  isImageTypeSupported(file) {
    const extension = file.substr((file.lastIndexOf('.') + 1));
    if (extension === 'jpg' || extension === 'jpeg' || extension === 'gif' || extension === 'png') {
        return true;
    } else {
        return false;
    }
  }

  submitGAEvent(eventCategory, eventAction, eventLabel) {
    this.googleAnalyticsService.emitEvent(eventCategory, eventAction, eventLabel, null);
  }
}

interface User {
  firstName: string,
  lastName: string,
  email: string,
  gender: string,
  country: string,
  dateOfBirth: string,
  zip: string,
  thumbnailURL: string
} 



// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/components/profile/profile.component.ts